import SideTool from "@/global/components/side-tool";
import classNames from "classnames";
import "./index.less"
import { useState } from "react";
import TnInput from "@/global/components/input/tn-input";
import PlaceButton from "@/global/components/place-button";
import { graphicStore } from "@/global/store/graphic-store";
import { ARCHI_SUB_CONTROL } from "@/passets/archibase-engine/enums/archi-sub-control";
import { useParams } from "react-router";
// 正整数正则匹配
const intRegex = /^[0-9]\d*$/
export default function Column() {

    // 项目id
    const { projectId } = useParams()
    // 柱类型
    const [columnType, setColumnType] = useState<"circle" | "rect">("rect")
    // 柱宽
    const [width, setWidth] = useState<string>("500")
    // 柱长
    const [length, setLength] = useState<string>("500")
    // 柱半径
    const [radius, setRadius] = useState<string>("500")

    // 激活添加柱二级控制器
    const addColumnClick = () => {
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(ARCHI_SUB_CONTROL.ASSIGNCOLUMNCONTROL.name);
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.setInitControlData.dispatch(
            {
                type: columnType,
                width: width || 0,
                length: length || 0,
                radius: radius || 0,
                projectId: projectId
            }
        )
    }

    return (
        <div className="column-main">
            <SideTool />
            <div className="column-side-body">
                <div
                    className={classNames({
                        "item": true,
                        "item-active": columnType == "rect"
                    })}
                    onClick={() => {
                        setColumnType("rect")
                    }}
                >
                    <div className="rec-icon" />
                    <div className="rec-input">
                        <TnInput
                            size="small"
                            value={length}
                            onTextChange={(e) => {
                                if (intRegex.test(e)) {
                                    setLength(e)
                                }
                            }}
                        />
                    </div>
                    <div className="text-1">
                        {"mm ×"}
                    </div>
                    <div className="rec-input">
                        <TnInput
                            size="small"
                            value={width}
                            onTextChange={(e) => {
                                if (intRegex.test(e)) {
                                    setWidth(e)
                                }
                            }}
                        />
                    </div>
                    <div className="text-2">
                        {"mm"}
                    </div>

                    {columnType == "rect" && (
                        <PlaceButton onClick={() => { addColumnClick() }} />
                    )}
                </div>
                <div
                    className={classNames({
                        "item": true,
                        "item-active": columnType == "circle"
                    })}
                    onClick={() => {
                        setColumnType("circle")
                    }}
                >
                    <div className="circle-icon" />
                    <div className="circle-input">
                        <TnInput
                            size="small"
                            value={radius}
                            onTextChange={(e) => {
                                if (intRegex.test(e)) {
                                    setRadius(e)
                                }
                            }}
                        />
                    </div>
                    <div className="text-3">
                        {"mm"}
                    </div>
                    {columnType == "circle" && (
                        <PlaceButton onClick={() => { addColumnClick() }} />
                    )}
                </div>
            </div>
        </div>
    )
}